export default "__VITE_ASSET__3d8eb93d__"